import { Space, Typography } from 'antd';
import { useSubjectDifficulties } from '../../model';
import { Tabs } from '../Tabs/ui';

const { Title, Paragraph } = Typography;

export const SubjectDifficulties = () => {
  const {
    state: { selectedTab, subjects, loading, columns },
    methods: { handleSelectTab },
  } = useSubjectDifficulties();

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <div>
        <Title level={4} style={{ marginBottom: 8 }}>
          Справочник сложности предметов
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          Укажите уровень сложности предметов для каждого класса. Значения должны быть
          положительными целыми числами (от 1).
        </Paragraph>
      </div>
      <Tabs
        selectedTab={selectedTab}
        onSelectTab={handleSelectTab}
        subjects={subjects}
        loading={loading}
        columns={columns}
      />
    </Space>
  );
};
